import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Divider from '../components/Common/Divider';
import '../css/Colors.css';
import './Home.css';

function Home() {
    const navigate = useNavigate();
    const location = useLocation();

    // Get email from URL parameter
    const urlParams = new URLSearchParams(location.search);
    const email = urlParams.get(process.env.REACT_APP_API_KEY_PARAM); 
    useEffect(() => {
        const observerOptions = {
            threshold: 0.15,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                }
            });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach(element => observer.observe(element));

        return () => {
            revealElements.forEach(element => observer.unobserve(element));
        };
    }, []);

    const handleStartSurvey = () => {
        if (email) {
            navigate(`/drivers-of-innovation?${process.env.REACT_APP_API_KEY_PARAM}=${email}`);
        } else {
            // Handle case where email is not present
            console.error('No email parameter found in URL');
        }
    };
    
    return (
        <div className='totalPage'>
            <section className="wrapper">
                <div id="featurednews" className="container mt-10 pb-6 reveal">
                    <h2 className="text-uppercase main-header">Welcome to Irish Funds' Survey Portal</h2>
                </div>
                <div className="container reveal reveal-delay-1">
                    <p>We are currently accepting responses for the Drivers of Innovation questionnaire. This important survey helps us understand and shape the future of innovation in the funds industry in Ireland.</p>
                    <p>Please click on the survey link to participate and share your valuable insights.</p>
                </div>
            </section>
            <Divider height={60} />

            <section className="wrapper bg-gradient-primary">
                <div className="container pb-10 reveal">
                    <h2 className="text-uppercase main-header">Active Surveys</h2>
                </div>
                <div className="container">
                    <div className="survey-box reveal">
                        <h3 className="survey-title">Drivers of Innovation Questionnaire</h3>
                        <div className="survey-content">
                            <p>Help shape the future of innovation in Ireland's funds industry by participating in our comprehensive survey.</p>
                            <ul className="survey-highlights">
                                <li>Share your insights on industry innovation</li>
                                <li>Contribute to industry-wide research</li>
                                <li>Help identify key trends and opportunities</li>
                            </ul>
                            <button className="survey-button" onClick={handleStartSurvey}>Start Survey</button>
                        </div>
                    </div>
                </div>
            </section>
            
            <Divider height={80} />
            <section className="wrapper bg-gradient-primary">
                <div className="container pb-12">
                    <div className="text-center commitment-section">
                        <h2 className="text-uppercase main-header reveal">Our Commitment</h2>
                        <div className="commitment-content">
                            <p className="lead reveal reveal-delay-1">Irish Funds is dedicated to supporting the continued growth and development of Ireland's Fund & Asset Management through:</p>
                            <div className="commitment-grid">
                                <div className="commitment-item reveal reveal-delay-1">
                                    <h4>Industry Leadership</h4>
                                    <p>Driving innovation and best practices in the funds industry</p>
                                </div>
                                <div className="commitment-item reveal reveal-delay-2">
                                    <h4>Research & Insights</h4>
                                    <p>Conducting valuable research to inform industry decisions</p>
                                </div>
                                <div className="commitment-item reveal reveal-delay-3">
                                    <h4>Collaboration</h4>
                                    <p>Working closely with industry stakeholders to shape the future</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Home;